let esRutValidoParaPromocion = false;
let collectedData = {}; // Objeto para recolectar datos de todos los pasos

function submitForm() {
    console.log('Submitting form');
    const submitButton = document.querySelector('#inscriptionForm button[type="button"]');
  
    if (submitButton.disabled || !esRutValidoParaPromocion) {
        console.log('Form submission blocked: submitButton.disabled =', submitButton.disabled, ', esRutValidoParaPromocion =', esRutValidoParaPromocion);
        alert('Por favor, espera la validación del RUT o asegúrate de que es elegible para la promoción.');
        return false; // Detener flujo de ejecución
    }
    submitButton.disabled = true;

    // Agregar la clase 'form-submitting' al contenedor del formulario para ocultar los labels
    document.querySelector('#inscriptionForm').classList.add('form-submitting');

    const rawPhone = document.getElementById('phone').value.replace(/\s/g, '');
    const phone = "+56" + rawPhone;

    collectedData = {
        firstName: document.getElementById('firstName').value,
        lastName: document.getElementById('lastName').value,
        nif: document.getElementById('rut').value,
        email: document.getElementById('email').value.trim(),
        phone: phone,
        pack: document.getElementById('service').value
    };

    if (!collectedData.firstName || !collectedData.lastName) {
        console.log('Validation error: firstName or lastName is missing');
        alert('Por favor, ingresa tu nombre y apellido completos.');
        submitButton.disabled = false;
        return false; // Detener flujo de ejecución
    }
    if (!validarRUT(collectedData.nif)) {
        console.log('Validation error: RUT is invalid');
        alert('El RUT ingresado no es válido. Asegúrate de ingresarlo correctamente.');
        submitButton.disabled = false;
        return false; // Detener flujo de ejecución
    }
    if (!validarCorreo(collectedData.email)) {
        console.log('Validation error: Email is invalid');
        alert('El correo electrónico ingresado no es válido. Asegúrate de ingresarlo correctamente.');
        submitButton.disabled = false;
        return false; // Detener flujo de ejecución
    }
    if (!validarTelefono(rawPhone)) {
        console.log('Validation error: Phone number is invalid');
        alert('Por favor, ingresa un número de teléfono válido con el formato 9 XXXX XXXX o X XXX XXXX.');
        submitButton.disabled = false;
        document.getElementById('phone').value = '';
        return false; // Detener flujo de ejecución
    }
    if (collectedData.pack === "default") {
        console.log('Validation error: Service pack not selected');
        alert('Por favor, selecciona un paquete de servicios.');
        submitButton.disabled = false;
        return false; // Detener flujo de ejecución
    }

    console.log('Datos de inscripción:', collectedData);
    return true; // Si todo está correcto, retornamos true
}

function setupRutBlurListener() {
    console.log('Setting up RUT blur listener');
    const rutInput = document.getElementById('rut');
    if (!rutInput) {
        console.log('RUT input not found, retrying...');
        setTimeout(setupRutBlurListener, 500);
    } else {
        rutInput.addEventListener('blur', function() {
            let rut = this.value.trim();
            if (rut === '') {
                console.log('RUT input is empty');
                return;
            }
            rut = formatearRUT(rut); // Formatear RUT
            this.value = rut;
            if (!validarRUT(rut)) {
                console.log('RUT is invalid');
                alert('El RUT ingresado no es válido.');
                this.value = '';
                this.focus();
            } else {
                realizarConsultaAPI(rut, this);
            }
        });
    }
}

function realizarConsultaAPI(rut, rutInput) {
    console.log("Validando RUT:", rut);
    fetch('https://belenus-shopify-app-2kc8s.ondigitalocean.app/api/validate-customer', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ nif: rut }),
    })
    .then(response => response.json())
    .then(data => {
        console.log('API response:', data);
        manejarRespuestaAPI(data, rutInput);
    })
    .catch(error => {
        console.error("Error al conectar con la API:", error);
        alert("Error de conexión al intentar validar el RUT.");
    });
}

function manejarRespuestaAPI(data, rutInput) {
    console.log("Respuesta de FLOWww: ", data);
    if (data.exists && data.lastPurchaseDate) {
        esRutValidoParaPromocion = false;
        deshabilitarPromocion(rutInput);
    } else {
        esRutValidoParaPromocion = true;
        habilitarPromocion(rutInput);
        if (data.exists) {
            // Usuario existe, obtener datos adicionales
            obtenerDatosCliente(data.customerId, rutInput);
        }
    }
    checkFormValidity();
}

function obtenerDatosCliente(clientId, rutInput) {
    console.log('Obteniendo datos del cliente:', clientId);
    fetch(`https://belenus-shopify-app-2kc8s.ondigitalocean.app/api/customerData?clientId=${clientId}`)
        .then(response => response.json())
        .then(data => {
            if (data.customerData) {
                console.log('Datos del cliente obtenidos:', data.customerData);
                collectedData.customerId = data.customerData.clientId;
                collectedData.customerToken = data.customerData.appToken;
                rutInput.disabled = true;
                checkFormValidity();
            } else {
                console.log('Error al obtener datos del cliente:', data);
                alert('Hubo un error al obtener los datos del cliente. Por favor, inténtalo de nuevo.');
            }
        })
        .catch(error => {
            console.error('Error al obtener los datos del cliente:', error);
            alert('Hubo un error al obtener los datos del cliente. Por favor, inténtalo de nuevo.');
        });
}

function habilitarPromocion(rutInput) {
    console.log('Promoción habilitada');
    localStorage.setItem('rut', rutInput.value);
    rutInput.style.backgroundColor = '#debec0';
    rutInput.style.border = 'none';
    rutInput.disabled = true;  // Bloquear permanentemente
    document.querySelector('label[for="rut"]').textContent = '🟢 Promoción disponible para ti';
    document.querySelector('label[for="rut"]').style.backgroundColor = '#debec0';
    document.querySelector('label[for="rut"]').style.color = '#ffffff';
}

function deshabilitarPromocion(rutInput) {
    console.log('Promoción deshabilitada');
    rutInput.style.backgroundColor = '#ffcccc';
    rutInput.style.border = 'none';
    rutInput.disabled = true;  // Bloquear permanentemente
    rutInput.value = '';
    document.querySelector('label[for="rut"]').textContent = '🔴 Promoción no disponible para este RUT';
    document.querySelector('label[for="rut"]').style.backgroundColor = '#ffcccc';
    document.querySelector('label[for="rut"]').style.color = '#ffffff';
}


function limpiarRUT(rut) {
    return typeof rut === 'string' ? rut.replace(/^0+|[^0-9kK]+/g, '').toUpperCase() : '';
}

function formatearRUT(rut) {
    let valor = limpiarRUT(rut);
    if (valor.length <= 1) return valor;
    
    let cuerpo = valor.slice(0, -1);
    let dv = valor.slice(-1).toUpperCase();
    
    if (cuerpo.length > 6) {
        cuerpo = cuerpo.slice(0, 8); // Limitar a 8 dígitos máximo
    }
    
    return `${cuerpo}-${dv}`;
}

function validarRUT(rut) {
    console.log('Validando RUT:', rut);
    var valor = limpiarRUT(rut);
    if (valor.length < 8) return false;

    var cuerpo = valor.slice(0, -1);
    var dv = valor.slice(-1).toUpperCase();
    var suma = 0;
    var multiplo = 2;

    for (var i = 1; i <= cuerpo.length; i++) {
        var index = parseInt(cuerpo.charAt(cuerpo.length - i), 10) * multiplo;
        suma += index;
        multiplo = (multiplo < 7) ? multiplo + 1 : 2;
    }

    var dvEsperado = 11 - (suma % 11);
    dvEsperado = dvEsperado === 11 ? 0 : dvEsperado;
    dvEsperado = dvEsperado === 10 ? "K" : dvEsperado;

    return dvEsperado.toString().toUpperCase() === dv;
}

function validarCorreo(email) {
    console.log('Validando correo:', email);
    const esCorreoValido = validator.isEmail(email);
    const terminaConCaracterEspecial = /[!#$%&'*+/=?^_`{|}~.-]$/.test(email);
    return esCorreoValido && !terminaConCaracterEspecial;
}

function validarTelefono(numero) {
    console.log('Validando teléfono:', numero);
    const regex = /^9[0-9]{8}$/;
    return regex.test(numero);
}

function handlePhoneBlur() {
    const phoneInput = document.getElementById('phone');
    const phoneValue = phoneInput.value.replace(/\s/g, '');
    if (!validarTelefono(phoneValue)) {
        alert('Por favor, ingresa un número de teléfono válido con el formato 9 XXXX XXXX o X XXX XXXX.');
        phoneInput.value = '';
    }
}

function checkFormValidity() {
    console.log('Checking form validity');
    const submitButton = document.querySelector('#inscriptionForm button[type="button"]');
    const firstName = document.getElementById('firstName').value.trim();
    const lastName = document.getElementById('lastName').value.trim();
    const rut = document.getElementById('rut').value.trim();
    const email = document.getElementById('email').value.trim();
    const phone = document.getElementById('phone').value.trim();
    const pack = document.getElementById('service').value;

    const isFormValid = firstName && lastName && validarRUT(rut) && validarCorreo(email) && validarTelefono(phone) && pack !== "default" && esRutValidoParaPromocion;

    console.log(`Form validity: ${isFormValid}`);
    submitButton.disabled = !isFormValid;
    submitButton.style.opacity = isFormValid ? '1' : '0.5'; // Cambiar opacidad del botón
}

document.addEventListener('DOMContentLoaded', () => {
    console.log('Setting up form handlers');
    setupRutBlurListener();

    const inputs = document.querySelectorAll('#inscriptionForm input, #inscriptionForm select');
    inputs.forEach(input => {
        input.addEventListener('input', checkFormValidity);
        input.addEventListener('blur', checkFormValidity);
    });

    const phoneInput = document.getElementById('phone');
    phoneInput.addEventListener('blur', handlePhoneBlur);
});
